import { Col, Row, Typography } from 'antd';
import { cloneDeep } from 'es-toolkit';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FilterCard from '../../../../../components/Cards/FilterCard';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import ContentSpinner from '../../../../../components/Spinners/ContentSpinner';
import { useGetSpotBidAddress } from '../../../hooks';
import SpotBidProviderCard from './SpotBidProviderCard';

const SportBidRouting = ({ handleSelectedSpotProviders = () => {} }) => {
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [distributorsList, setDistributorsList] = useState([]);
  const [selectedAllDistributors, setSelectedAllDistributors] = useState(false);
  const { shipmentDetails } = useSelector((state) => state.shipment);
  const {
    selectedCompany: { companyId },
  } = useSelector((state) => state.auth);
  const {
    data: spotBidAddressList,
    isSuccess: spotBidSuccess,
    isLoading: isSpotBidLoading,
  } = useGetSpotBidAddress({
    Shipmentkey: shipmentDetails?.data?.shipmentKey,
    CustomerKey: companyId,
    RoutingType: 1,
  });

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleDistributerClick = (e, index) => {
    const {
      target: { checked },
    } = e;
    const data = cloneDeep(distributorsList);
    data[index].selected = checked;
    data[index].actualIndex = index;
    if (!checked) {
      data[index].providers = data[index].providers.map((row) => ({
        ...row,
        selected: false,
      }));
    }
    setDistributorsList(data);
  };

  useEffect(() => {
    if (spotBidSuccess) {
      setDistributorsList(spotBidAddressList);
    }
  }, [spotBidSuccess, spotBidAddressList]);

  useEffect(() => {
    handleSelectedSpotProviders(selectedProviders?.filter((item) => item.selected));
  }, [selectedProviders]);

  const handleAllDistributorsCheckbox = (e) => {
    const {
      target: { checked },
    } = e;
    setSelectedAllDistributors(checked);
    let data = cloneDeep(distributorsList);
    if (checked) {
      data = data.map((row, idx) => ({
        ...row,
        selected: true,
        actualIndex: idx,
      }));
      setDistributorsList(data);
    } else {
      data = data.map((row, idx) => ({
        ...row,
        selected: false,
        actualIndex: idx,
      }));
      setDistributorsList(data);
    }
  };

  const providersList = useMemo(() => {
    let data = [];
    distributorsList.forEach((row) => {
      if (row.selected === true) {
        data = [...data, ...row.providers];
      }
    });
    return data;
  }, [distributorsList]);

  useEffect(() => {
    setSelectedProviders(providersList);
  }, [providersList]);

  const selectedDistributors = useMemo(() => distributorsList?.filter((item) => item.selected), [distributorsList]);

  const handleProvidersChange = (providers, index) => {
    if (index >= 0) {
      const data = cloneDeep(distributorsList);
      if (data[index]) {
        data[index].providers = providers;
        setDistributorsList([...data]);
      }
    }
  };

  useEffect(() => {
    setSelectedAllDistributors(distributorsList.length === selectedDistributors.length);
  }, [selectedDistributors]);

  return (
    <Row className="overflow-hidden h-100" gutter={30}>
      <Col sm={8} className="h-100 overflow-hidden ">
        <FilterCard
          title={
            <Row>
              <Col>
                <FormCheckBox
                  checkBoxClass="normal-checkbox"
                  label={<span className="ml-0"> {t('translation:shipmentAdd.spotBid.distributors')}</span>}
                  className="m-0 "
                  onChange={handleAllDistributorsCheckbox}
                  checked={selectedAllDistributors}
                />
              </Col>
              <Col />
            </Row>
          }
          className="h-100 overflow-hidden d-flex flex-direction-column"
          showBorder
        >
          <div className="custom-scroll-bar flex-1 ">
            {isSpotBidLoading ? (
              <ContentSpinner height="h-80" />
            ) : (
              <>
                {distributorsList.map(({ distributionName, selected }, idx) => (
                  <Row
                    align="middle"
                    gutter={15}
                    className="border-bottom-muted px-16 py-10"
                    key={distributionName}
                    wrap={false}
                  >
                    <Col sm={24}>
                      <Typography.Text
                        ellipsis={{
                          tooltip: distributionName,
                        }}
                        className="cursor-pointer fw-600 f-14 w-95"
                      >
                        <FormCheckBox
                          checkBoxClass="normal-checkbox w-100"
                          className="m-0 "
                          label={distributionName}
                          onChange={(e) => handleDistributerClick(e, idx)}
                          checked={Boolean(selected)}
                          name={undefined}
                        />
                      </Typography.Text>
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </div>
        </FilterCard>
      </Col>
      <Col sm={16} className="h-100  custom-scroll-bar">
        {selectedDistributors.map(({ providers, distributionName, actualIndex }, idx) => (
          <SpotBidProviderCard
            providers={providers}
            distributionName={distributionName}
            key={distributionName}
            index={idx}
            handleProvidersChange={handleProvidersChange}
            actualIndex={actualIndex}
          />
        ))}
      </Col>
    </Row>
  );
};

export default SportBidRouting;
